<div id="freightShip" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div *ngIf="loadContent" class="child-body">
      <div class="inner-subBlock-wrapper">
        <!-- <div class="page-title-wrapper">
          <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
        </div> -->

        <div id="freight-detail">
          <!-- <div class="freight-title">
                      Your shipping and freight :
                      <div style="display: inline-block;">
                          Zone {{freightModel?.zoneID}}
                      </div>
                  </div> -->
          <hr style="border: .5px solid #e6e6e6;margin: 15px 0;">
          <!-- <div class="warning" *ngIf="warning.length > 0">
            {{warning}} 
          </div> -->
          <table class="text-table">
            <tbody ngbRadioGroup name="radioBasic" [(ngModel)]="shippingMethod">
              <!-- <tr class="freight-table">
                <td>
                  <label ngbButtonLabel>
                    <input ngbButton type="radio" (click)="chooseRoadRadio(freightModel)"
                      [checked]="freightModel?.shippingMethod && freightModel?.shippingMethod?.toLowerCase() =='road'"
                      [value]="roadRadioValue">
                  </label>
                  <span>Standard Road Freight</span>
                  <span style="font-weight: bold; color: #C20047;"
                    *ngIf="freightModel?.country && freightModel?.country?.toUpperCase()=='NZ' && freightModel?.freeFreightPromo=='1'">
                    (Web Free Freight Promotion)
                  </span>
                  <span class="road-total" *ngIf="freightModel?.roadFreight">
                    ({{freightModel?.roadFreight | currency:'AUD':'symbol-narrow':'.2-2':'NZD':'symbol-narrow'}})
                  </span>
                  <span class="road-total" *ngIf="!freightModel?.roadFreight">
                    (Free Freight)
                  </span>
                </td>
              </tr>

              <tr class="freight-table" *ngIf="freightModel?.country && freightModel?.country?.toUpperCase()=='AU'">
                <td style="padding-top:0;font-size:12px !important;">
                  <label ngbButtonLabel>
                    <input type="radio" ngbButton (click)="chooseAirRadio(freightModel)"
                      [checked]="freightModel?.shippingMethod && freightModel?.shippingMethod?.toLowerCase() =='air'"
                      [disabled]="!freightModel?.IsAirQuoteRequired && !freightModel?.airFreight" [value]="airRadioValue">
                  </label>
                  <span>Air Freight</span>
                  <span class="air-total" *ngIf="!freightModel?.IsAirQuoteRequired && freightModel?.airFreight">
                    {{freightModel?.airFreight | currency:'AUD':'symbol-narrow':'.2-2'}}
                  </span>
                  <span class="air-total" *ngIf="!freightModel?.IsAirQuoteRequired && !freightModel?.airFreight">
                    Not Available
                  </span>
                  <span class="air-total" *ngIf="freightModel?.IsAirQuoteRequired">
                    Manual Quote Required
                  </span>
                </td>
              </tr> -->
              <div *ngIf="!isQuoteRequired" >
                <tr class="freight-table" *ngFor="let carrier of carriers">
                  <td class="cursor-pointer" (click)="chooseFreightCarrier(carrier)" for="carrier-code">
                    <div>
                      <label ngbButtonLabel>
                        <input name="carrier-code" ngbButton type="radio" [value]="carrier?.serviceCode">
                      </label>
                      <span>{{carrier?.serviceName}}</span>
                      <span class="road-total">
                        ({{carrier?.calculated_Price_Ex_GST | currency: (freightModel?.country?.toUpperCase()=='AU' ? 'AUD' : 'NZD') :'symbol-narrow':'.2-2'}})
                      </span>
                    </div>
                    <div>
                      <span>{{carrier?.serviceDescription}}</span>
                    </div>
                  </td>
                </tr>
              </div>
              <tr *ngIf="isQuoteRequired">
                <td>
                    <input name="manual-quote" value="" type="radio" checked>
                    <span class="light-text description-padding">
                      One or more items in this cart requires additional information to accurately calculate any required freight.  After placing this order a Dicker Data representative will be in contact should we require further information.
                    </span>
                </td>
                <br/>
              </tr>
            
            </tbody>
            <!-- <tbody ngbRadioGroup name="radioBasic" [(ngModel)]="shippingMethod"
              *ngIf="freightModel?.country && freightModel?.country?.toUpperCase()=='NZ'">
              <tr class="freight-table">
                <td>
                  <label ngbButtonLabel>
                    <input ngbButton type="radio" value="ROAD">
                  </label>
                  <span>Standard Road Freight</span>
                  <span style="font-weight: bold; color: #C20047;" *ngIf="freightModel?.freeFreightPromo=='1'">
                    (Web Free Freight Promotion)
                  </span>
                  <span class="road-total" *ngIf="freightModel?.freeFreightPromo!='1' && freightModel?.roadFreight">
                    ({{freightModel?.roadFreight | currency:'NZD':'symbol-narrow':'.2-2'}})
                  </span>
                  <span class="road-total" *ngIf="freightModel?.freeFreightPromo!='1' && !freightModel?.roadFreight">
                    Free Freight
                  </span>
                </td>
              </tr>
            </tbody> -->
          </table>

          <!-- <hr style="border: .5px solid #e6e6e6;margin: 15px 0;"> -->

          <textarea [(ngModel)]="shippingInstructions" id="shippingInstructions" name="shippingInstructions"
            placeholder="Shipping instructions" rows="5" cols="55"></textarea>
          <div class="light-text description-padding">
            Dicker Data endeavours to meet all requested shipping instructions where reasonable,
            however, we do not guarantee this service.
          </div>
        </div>

      <div class="freight-button-list">
        <button class="button button-red button-large text-initial" id="next-button"
          (click)="SubmitFreight()">Next</button>
      </div>
      <div id="bottom-navigation">
        <button (click)="goBackFreight()">Previous</button>
        <span>&nbsp;|&nbsp;</span>
        <!-- <button (click)="backtoCart()">Back to cart</button> -->
<!--         
        <ng-container *ngIf="serial;else goRenewals">
          <button class="btnLink" (click)="backtoRenewals()">Back to renewals</button>
        </ng-container>
        <ng-template #goRenewals>
          <button class="btnLink" (click)="backtoCart()">Back to cart</button>
        </ng-template> -->
        <ng-container [ngSwitch]="backto">
          <button *ngSwitchCase="'renewal'" (click)="backtoRenewals()">Back to renewals
          </button>
          <button *ngSwitchCase="'quote'"  (click)="backtoQuotes()">Back to quotes
          </button>
          <button *ngSwitchDefault  (click)="backtoCart()">Back to cart</button>        
        </ng-container>
        
      </div>
    </div>
  </div>
  <loading-screen *ngIf="!loadContent" backDropWidth='350' [showInnerLoading]="true"
      (currentLoadingStatus)="onLoading($event)"></loading-screen>
</div>

<ng-template #tipContent>
  <div style="padding: 10px; border-bottom: 1px gray solid;">
    <div class="tooltip-title"><strong>Zone {{freightModel?.zoneID}}</strong></div>
    <table class="tooltip-table">
      <tr style="font-size: 15px;border-bottom: solid gray 1px">
        <th scope="col" style="width: 10%">
          State
        </th>
        <th scope="col" style="width: 60%">
          Location
        </th>
        <th scope="col" style="width: 30%">
          PostCode
        </th>
      </tr>
      <tr *ngFor="let item of zoneDetailModel">
        <td>
          {{item.state}}
        </td>
        <td class="expand">
          {{item.location}}
        </td>
        <td>
          {{item.postcode}}
        </td>
      </tr>
    </table>
  </div>
</ng-template>